import type { FunctionComponent } from "react";

import { section } from "shared/data";
import { useEditionValue } from "shared/lib/edition";
import { useGetHomeAsPath } from "shared/lib/router";

import { page as HomePage } from "scmp-app/pages/home";
import { page as SectionPage } from "scmp-app/pages/section";

import {
  StyledLogoScmp,
  StyledLogoStyle,
  StyledLogoStyleCaption,
  StyledLogoStyleCaptionMobile,
} from "./logo/styles";
import {
  Container,
  Copyright,
  DownloadAppLink,
  Footer,
  LogoSCMPContainer,
  LogoStyleContainer,
  StyledStyleSitemap,
  StyledStyleSocialMedia,
  Wrapper,
} from "./styles";

export const StyleFooter: FunctionComponent = () => {
  const edition = useEditionValue();
  const homeAsPath = useGetHomeAsPath();
  const downloadAppLink = "https://scmp.onelink.me/3586748601/lay93iwg";

  const { pathname: sectionStylePagePathname, query: sectionStylePageQuery } = SectionPage.route({
    appBarVariant: "scmp/magazines-style",
    entityId: section.style.entityId,
    slide: "main",
  });
  const { pathname: homePagePathname, query: homePageQuery } = HomePage.route({
    edition,
    slide: "main",
  });

  return (
    <>
      <Container>
        <Wrapper>
          <LogoStyleContainer
            as={section.style.urlAlias}
            pathname={sectionStylePagePathname}
            query={{ ...sectionStylePageQuery }}
          >
            <StyledLogoStyle />
            <StyledLogoStyleCaption />
            <StyledLogoStyleCaptionMobile />
          </LogoStyleContainer>
          <StyledStyleSocialMedia />
          <StyledStyleSitemap />
          <DownloadAppLink href={downloadAppLink} rel="noreferrer" target="_blank">
            DOWNLOAD THE SCMP APP
          </DownloadAppLink>
          <Footer>
            <LogoSCMPContainer
              as={homeAsPath}
              pathname={homePagePathname}
              query={{ ...homePageQuery }}
            >
              <StyledLogoScmp />
            </LogoSCMPContainer>
            <Copyright>
              Copyright © {new Date().getFullYear()} South China Morning Post Publishers Ltd. All
              rights reserved.
            </Copyright>
          </Footer>
        </Wrapper>
      </Container>
    </>
  );
};

StyleFooter.displayName = "StyleFooter";
